import { useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";

// Settings page components
import DashboardLayout from "parts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "parts/Navbars/DashboardNavbar";
import Footer from "parts/Footer";

import Sidenav from "components/account/Sidenav";
import Header from "components/account/Header";
import BasicInfo from "components/account/BasicInfo";
import ChangeEmail from "components/account/ChangeEmail";
import ChangePassword from "components/account/ChangePassword";
import Accounts from "components/account/Accounts";
import Sessions from "components/account/Sessions";
import DeleteAccount from "components/account/DeleteAccount";

import { useMaterialUIController, setLayout } from "context";
import { useSessionContext } from "context/SessionContext";

function AccountSettings(): JSX.Element {
  const [controller, dispatch] = useMaterialUIController();
  const { userInfo, setUserInfo } = useSessionContext();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [dispatch]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Sidenav />
          </Grid>
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header profile={userInfo} />
                </Grid>
                <Grid item xs={12}>
                  <BasicInfo profile={userInfo} setProfile={setUserInfo} />
                </Grid>
                <Grid item xs={12}>
                  <ChangeEmail />
                </Grid>
                <Grid item xs={12}>
                  <ChangePassword />
                </Grid>
                {/* <Grid item xs={12}>
                  <Accounts />
                </Grid> */}
                <Grid item xs={12}>
                  <Sessions />
                </Grid>
                {/* <Grid item xs={12}>
                  <DeleteAccount />
                </Grid> */}
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AccountSettings;
